import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/payment-gates/{paymentGateId}/assignees';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getPaymentGateAssignees = async ({ paymentGateId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { paymentGateId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getPaymentGateAssignees;
